import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  DataTable,
  Field,
  CurrencyField,
  DateTimeField,
} from '../../../commons/DataTable';
import { useAuth } from '../../../commons/Auth';
import CustomerTypeField from '../../../commons/DataTable/CustomerTypeField';
import CustomerVatCodeField from '../../../commons/DataTable/CustomerVatCodeField';
import IAFCustomCheckboxesInsurances from '../../../commons/Checkboxes/IAFCustomCheckboxesInsurance';
import CustomerNameField from '../../../commons/DataTable/CustomerNameField';

function InsurancesRoyaltyTableBackoffice({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  showEmptyTableMessage,
  truncateTable,
  onSelectChange,
  allowedRoles = [],
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin, newUserType = '' }] = useAuth();
  const { offset, limit } = query;

  const onCheck = (report) => {
    if (!allowedRoles.includes('superadmin')) {
      return;
    }
    onSelectChange(report);
  };

  return (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      {!truncateTable &&
        (newIsAdmin ? (
          <IAFCustomCheckboxesInsurances
            onSelectChange={onCheck}
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          <></>
        ))}
      <Field
        title="Codice polizza"
        source="policy_code"
        visible={!truncateTable}
      />

      <Field
        title="Etichetta polizza"
        source="insurance_code"
        visible={!truncateTable}
      />

      <Field
        title="Intestatario"
        source="admin.businessName"
        className="text-left"
        visible={!truncateTable}
      />
      <Field
        title="Nome Fornitore"
        source="supplier.businessName"
        className="text-left"
        visible={!truncateTable}
      />
      <Field
        title="Tipo agenzia"
        source="agencyType"
        className="text-left"
        visible={!truncateTable}
      />
      <CustomerNameField
        title="Cliente"
        source="customer.name"
        visible={!truncateTable}
      />
      <CustomerVatCodeField
        title="P.Iva / Codice fiscale cliente"
        visible={!truncateTable}
      />
      <CustomerTypeField
        title="Tipologia cliente"
        source="customerType"
        visible={!truncateTable}
      />
      <DateTimeField
        title="Data inizio"
        source="start_date"
        format="DD/MM/YYYY"
        visible={!truncateTable}
      />
      <DateTimeField
        title="Data fine"
        source="end_date"
        format="DD/MM/YYYY"
        visible={!truncateTable}
      />
      <Field title="Fraz" source="fraz" visible={!truncateTable} />
      <CurrencyField
        title="Imponibile"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="Importo da incassare"
        source="gross"
        className="txt-table-right"
      />
    </DataTable>
  );
}

export default withRouter(InsurancesRoyaltyTableBackoffice);
